import React from 'react';

import Option from './Option';

const Options = ({options, ...props}) => (
    Boolean(options) && options.map(option => <Option {...props} {...option} key={option.value} />)
);

export default Options;
